import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const hogarModelSlice = createSlice({
    name: "hogarModel",
    initialState,
    reducers: {
        setHogarModel(state, action) {
            state.hogarModel = action.payload;
        }
    }
});

const { actions, reducer } = hogarModelSlice;

export const { setHogarModel } = actions;

export const setHogarModelAction = (data) => async (dispatch) => {
    dispatch(setHogarModel(data));
};

export default reducer;
